import React, { useEffect, useState } from 'react';

const Splashscreen = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = 'hidden';
    }

    const handleAnimationEnd = (e) => {
      // Matches the animation name defined in the CSS
      if (e.animationName === 'fadeOut') {
        setIsVisible(false);
        document.body.style.overflow = '';
      }
    };
    const splash = document.getElementById('splash-screen');
    if (splash) {
      splash.addEventListener('animationend', handleAnimationEnd);
    }
    return () => {
      document.body.style.overflow = '';
      if (splash) {
        splash.removeEventListener('animationend', handleAnimationEnd);
      }
    };
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <>
      <style>
        {`
          @keyframes fadeOut {
            to { opacity: 0; visibility: hidden; }
          }
          @keyframes logoEntrance {
            0% { opacity: 0; transform: scale(0.9); filter: blur(10px); }
            100% { opacity: 1; transform: scale(1); filter: blur(0); }
          }
          @keyframes progress {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(250%); }
          }
          .animate-fade-out {
            animation: fadeOut 0.6s ease-in-out forwards;
            animation-delay: 2.5s;
          }
          .animate-entrance {
            animation: logoEntrance 1s cubic-bezier(0.22, 1, 0.36, 1) forwards;
          }
          .animate-progress {
            animation: progress 2s ease-in-out infinite;
          }
        `}
      </style>
      <div
        id="splash-screen"
        className="fixed inset-0 z-[60] flex items-center justify-center animate-fade-out bg-primary overflow-hidden"
      >
        {/* Background Gradient with Primary Color */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#00B2A9] via-[#009E96] to-[#00837D]"></div>
        
        <div className="relative flex flex-col items-center px-4">
          {/* Logo Container */}
          <div className="animate-entrance">
            <img
              src="/images/logo.png"
              alt="MexaMedico Logo"
              className="h-20 md:h-28 w-auto drop-shadow-xl"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Splashscreen;